import { post, remove } from '@/api/v1';
import { NotificationToken } from './api.types';

export const addRegistrationToken = (request: NotificationToken) =>
  post('registration/token', request);

export const removeRegistrationToken = (request: NotificationToken) =>
  remove('registration/token', request);
